/*
 * @Author: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-11-27 20:05:26
 * @LastEditors: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2026-01-28 17:38:32
 * @FilePath: \mpc-3\features\mpc-common\src\components\SForm\SFormElement\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, {
  ReactHTMLElement,
  HTMLAttributes,
  forwardRef,
  useState,
  useRef,
  useMemo,
  useEffect,
} from 'react';
import dayjs from 'dayjs';
import _omit from 'lodash/omit';
import {
  Radio,
  Input,
  DatePicker,
  InputNumber,
  InputPercent,
  Select,
  Switch,
  Checkbox,
} from '@bedrock/components';
import { SUpload } from './SUpload';
import { S3Upload } from './S3Upload';
import CurrencyType from './CurrencyType';
import CopeWrapper from './CopeWrapper';
import { DEFAULT_DATE_FORMAT } from '#utils/date';
import { enums } from '#services/api';
import { budgetToNumber } from '#components/SForm/SFormElement/utils';
import TextShow from '#components/SForm/SFormElement/TextShow';
import SFormElementWrapper, {
  ElementWrapperProps,
} from '#components/SForm/SFormElementWrapper';
import { useDebounceEffect, useMemoizedFn } from 'ahooks';
import { isBlank } from '@bedrock/utils';
import Decimal from 'decimal.js';
export { default as MockInputShow } from './TextShow';
import { isEqual } from "lodash";
import TextAreaShow from './TextAreaShow/index';
import NumberCurrency from './NumberCurrency';
import TextAreaPropover from './TextAreaPropover';
import TextAreaWithUpload from './TextAreaWithUpload';
import SInputPercent from './InputPercent';
import TextAreaPopover from './TextAreaPropover';


// 高阶函数，包裹组件，在组件上添加拼音输入法输入结束事件
/**
 * 中文输入法组合输入包装器高阶组件
 * 解决中文输入法在输入过程中频繁触发onChange事件的问题
 * 确保只在输入法组合输入完成后才触发onChange回调
 */
const compositionWrapperHOC = <T extends React.ComponentType<any>>(Component: T) => {
  return forwardRef<any, React.ComponentProps<T>>((props, ref) => {
    const { value, onChange, ...restProps } = props;
    
    // 本地状态，用于在组合输入过程中临时保存输入值
    const [localValue, setLocalValue] = useState(value);
    
    // 标识当前是否处于输入法组合输入状态
    const isComposingRef = useRef(false);

    const dealValue = useMemoizedFn((value: any) => {
      // 如果有maxLength属性则截取到maxLength长度
      if (restProps.maxLength) {
        return value.slice(0, restProps.maxLength);
      } else {
        return value;
      }
    });

    // 当外部value变化时，同步更新本地状态
    useEffect(() => {
      if (value !== localValue && !isComposingRef.current) {
        setLocalValue(value);
      }
    }, [value, localValue]);

    // 处理输入事件
    const handleInput = useMemoizedFn((e: React.FormEvent<HTMLInputElement>) => {
      const inputValue = e.currentTarget.value;
      
      // 无论是否在组合输入状态，都更新本地状态以保证UI响应
      setLocalValue(inputValue);
      
      // 只有在非组合输入状态下才触发onChange回调
      if (!isComposingRef.current && onChange) {
        onChange(inputValue);
      }
    });

    // 处理输入法组合开始事件
    const handleCompositionStart = useMemoizedFn(() => {
      isComposingRef.current = true;
    });

    // 处理输入法组合结束事件
    const handleCompositionEnd = useMemoizedFn((e: React.CompositionEvent<HTMLInputElement>) => {
      isComposingRef.current = false;
      
      // 组合输入结束后，触发最终的onChange回调
      const finalValue = e.currentTarget.value;
      const newValue = dealValue(finalValue);
      setLocalValue(newValue);
      onChange?.(newValue);
    });

    // 解决类型不兼容问题，显式指定props类型，避免传递多余的属性
    return (
      // @ts-ignore
      <Component
        ref={ref}
        {...(restProps as Omit<React.ComponentProps<T>, 'value' | 'onChange'>)}
        value={localValue}
        onInput={handleInput}
        onCompositionStart={handleCompositionStart}
        onCompositionEnd={handleCompositionEnd}
      />
    );
  });
};


const SInput = compositionWrapperHOC(Input);
const STextArea = compositionWrapperHOC(Input.TextArea);

export type SFormComponentClass =
  | 'input'
  | 'radio'
  | 'checkbox'
  | 'singleCheckbox'
  | 'select'
  | 'treeSelect'
  | 'textarea'
  | 'textareapropover'
  | 'switch'
  | 'inputNumber'
  | 'inputPercent'
  | 'currencyType'
  | 'datepicker'
  | 'datePicker'
  | 'editor'
  // 'projectCode' |
  | 'upload'
  | 's3upload';

type ComponentTypeMap = {
  radio: typeof Radio;
  input: typeof Input;
  datepicker: typeof DatePicker;
  datePicker: typeof DatePicker;
  inputNumber: typeof InputNumber;
  inputPercent: typeof InputPercent;
  select: typeof Select;
  switch: typeof Switch;
  treeSelect: typeof Select;
  textarea: typeof Input.TextArea;
  textareapropover: typeof TextAreaPropover;
  editor: typeof Input.TextArea;
  currencyType: typeof CurrencyType;
  upload: typeof SUpload;
  s3upload: typeof S3Upload;
};

// 泛型轨道
// 如果 入参是t则结果是t，如果入参是t[] 则函数返回是t[]
// 比如不可以入参是t[]， 出参是t

export type SelectFormat<T> = {
  /** 选择的下拉选项到form值 */
  optionsToValue: (
    value: string | number,
    options: ({ value: string | number; name: string } & T)[]
  ) => T;
  /** form值映射到下拉选项到 */
  valueToSelectKey: (value: T) => string | number;
};

// 生成一个函数，用于将options转换为value，将value转换为selectKey
function formatToAarrayFn<T>(format: SelectFormat<T>) {
  return {
    optionsToValue: (
      value: string | number,
      options: ({ value: string | number; name: string } & T)[]
    ) => {
      if (Array.isArray(value)) {
        return value.map((v) => format.optionsToValue(v, options));
      }
      return format.optionsToValue(value, options);
    },
    valueToSelectKey: (value: T | T[]) => {
      if (Array.isArray(value)) {
        return value.map((v) => format.valueToSelectKey(v));
      }
      return format.valueToSelectKey(value);
    },
  };
}

export type ComponentProps<T extends keyof ComponentTypeMap | never> =
  (T extends keyof ComponentTypeMap
    ? React.ComponentProps<ComponentTypeMap[T]>
    : React.HTMLAttributes<HTMLDivElement>) &
    ElementWrapperProps;

export type PureFormItemProps = {
  componentClass?: SFormComponentClass | React.ComponentClass<any> | React.FC;
  className?: string;
  formItemKey?: string;
  value?: any;
  options?: any[] | ((props: PureFormItemProps) => any[] | Promise<any[]>);
  optionsKey?: string;
  onChangeKey?: (params: ChangeParams) => void;
  onChange?: (e: any) => void;
  view?: boolean;
  showComponent?: React.ReactElement | ((value: any) => React.ReactElement);
  selectFormat?: SelectFormat<any>;
  isCopyPlaceholder?: boolean;
  ableCopy?: boolean; // 只读态是否有复制按钮
  isCopy?: boolean; // TODO: 待废弃属性，只读态是否有复制按钮
  // 需要options变化的组件是否启用当options变空的时候通过onChange清空现有值
  clearValueWhenOptionsEmpty?: boolean;
};

type ExtendedPureFormItemProps<T extends SFormComponentClass> =
  PureFormItemProps & ComponentProps<T>;

export interface ChangeParams {
  formItemKey: string;
  value: any;
}

// 通用表单元素
const PureFormItem: React.FC<ExtendedPureFormItemProps<SFormComponentClass>> = (
  props
) => {
  let { onChange, formItemKey, onChangeKey, value, selectFormat, clearValueWhenOptionsEmpty } = props;
  const handleChange = (e: any, key?: any) => {
    const value = e && e.target ? e.target.value : e;
    onChangeKey?.({
      formItemKey: typeof key === 'string' ? key : formItemKey,
      value,
    });
    onChange?.(value);
  };

  // 生成selectFormatFn
  const selectForFormatFn = useMemo(() => {
    let selectFormatS = selectFormat;
    if (!selectFormatS) {
      selectFormatS = {
        optionsToValue: (value, options) => value,
        valueToSelectKey: (value) => value,
      };
    }
    return formatToAarrayFn(selectFormatS);
  }, [selectFormat]);

  const [options, setOptions] = React.useState<any[]>([]);

  useEffect(() => {
    if (typeof props.options === 'function') {
      Promise.resolve(
        props.options({
          formItemKey: formItemKey,
          optionsKey: props.optionsKey,
        })
      ).then((res: any) => {
        setOptions(res);
      });
    } else {
      const { options, optionsKey } = props;
      if (Array.isArray(options) && options?.length > 0) {
        setOptions(options);
      } else if (optionsKey) {
        setOptions(enums[optionsKey]?.values?.() || []);
      } else {
        setOptions([]);
      }
    }
  }, [formItemKey, props.optionsKey, props.options]);

  // 如果传进来的optinos为空，并且当前value有值，则还需要清掉当前的值
  useDebounceEffect(() => {
    if (props.view || !clearValueWhenOptionsEmpty) {
      return;
    }

    const checkAndClearValue = (nextOptions) => {
      if (!isEqual(nextOptions, options)) {
        // 如果options变了，也顺带更新一下本地options
        setOptions(nextOptions);

        if (isBlank(nextOptions) && !isBlank(value)) {
          handleChange(undefined);
        }
      }
    }

    if (typeof props.options === 'function') {
      Promise.resolve(
        props.options({
          formItemKey: formItemKey,
          optionsKey: props.optionsKey,
        })
      ).then((res: any) => {
        if (Array.isArray(res)) {
          checkAndClearValue(res);
        }
      });
    } else {
      let nextOptions;
      if (Array.isArray(props.options)) {
        nextOptions = props.options;
      } else if (props.optionsKey) {
        nextOptions = enums[props.optionsKey]?.values?.() || [];
      }
      checkAndClearValue(nextOptions);
    }
  }, [props.options], { wait: 100 });

  function findOption(value: any) {
    return options?.find((o) => o.value?.toString() === value?.toString());
  }

  const StrOptionValue = useMemo(() => {
    if (Array.isArray(value)) {
      return value.map((v) => findOption(v)?.name)?.join('，');
    }
    return findOption(value)?.name || '--';
  }, [options, value]);

  const renderItem = () => {
    const {
      formItemKey,
      componentClass,
      value,
      children,
      optionsKey,
      view = false,
      showComponent,
      isCopyPlaceholder = false,
      ...others
    } = props;

    const otherProps = _omit(others, [
      'options',
      'optionsKey',
      'onChangeKey',
      'onChange',
    ]);

    // 处理枚举,解决swagger枚举值为字符串，但是真实返回是数字的问题
    let strValue = value;
    if (enums[optionsKey]) {
      if (Array.isArray(strValue)) {
        strValue = strValue.map((v) => findOption(v)?.value);
      } else {
        strValue = findOption(strValue)?.value;
      }
    }

    // 查看模式
    let lowerComponentClass = '';
    if (typeof componentClass === 'string') {
      lowerComponentClass = componentClass?.toLowerCase?.();
    }

    if (view) {
      if (showComponent) {
        if (typeof showComponent === 'function') {
          return showComponent(value);
        }
        return showComponent;  
      } else {
        switch (lowerComponentClass) {
          case 'text_with_upload': {
            return (
              // view为true时，需要传入value
              <TextAreaWithUpload {...otherProps} value={value} view={view} />
            )
          }
          case 'radio':
          case 'select':
          case 'treeselect': {
            strValue = selectForFormatFn.valueToSelectKey(value);
            if (Array.isArray(strValue)) {
              return (
                <TextShow
                  text={strValue.map((v) => findOption(v)?.name)?.join('，')}
                  {...otherProps}
                />
              );
            }
            return (
              <TextShow
                text={findOption(strValue)?.name || '--'}
                {...otherProps}
              />
            );
          }
          case 'switch': {
            // return <TextShow text={value ? '是' : '否'} {...otherProps} />;
            return <Switch checked={strValue} disabled {...otherProps} />;
          }
          case 'datepicker':
          case 'datePicker': {
            let values = Array.isArray(value) ? value : [value];
            return <TextShow text={values?.join?.(' ~ ')} {...otherProps} />;
          }
          case 'inputpercent': {
            let percentText =
              value === undefined || value === null
                ? ''
                : `${new Decimal(value).mul(100).toString()}%`;
            if (otherProps.valueType === 'string' && percentText) {
              percentText = value.toString() + '%';
            }
            return <TextShow text={percentText} {...otherProps} />;
          }
          case 'textarea':
          case 'editor': {
            // 处理换行符和空格
            if (!value) return <TextShow />;
            return (
              <TextAreaShow value={value} {...otherProps} />
            );
          }
          case 'textareapropover': {
            return <TextAreaShow value={value} {...otherProps} />;
          }
          case 'currencytype': {
            return <CurrencyType value={value} view={true} {...otherProps} />;
          }
          case 'upload': {
            if (!value?.length) {
              return <TextShow />;
            }
            return <SUpload fileList={value} view={true} {...otherProps} />;
          }
          case 's3upload': {
            if (!value?.length) {
              return <TextShow />;
            }
            return <S3Upload value={value} view={true} {...otherProps} />;
          }
          case 'singlecheckbox': {
            return <Checkbox className='for-show' checked={strValue} disabled {...otherProps}>{children}</Checkbox>;
          }
          case 'input':
          case 'inputnumber':
          default: {
            return <TextShow text={value} {...otherProps} />;
          }
        }
      }
    }
    switch (lowerComponentClass) {
      case 'text_with_upload': {
        return (
          <TextAreaWithUpload {...otherProps} onChange={handleChange} value={value} />
        )
      }
      case 'radio': {
        return (
          <Radio.Group
            onChange={(evt) => {
              handleChange(evt);
            }}
            value={strValue}
            options={options}
            {...otherProps}
          />
        );
      }
      case 'checkbox': {
        return (
          <Checkbox.Group
            onChange={(evt) => {
              handleChange(evt);
            }}
            value={strValue}
            options={options}
            {...otherProps}
          />
        );
      }
      case 'singlecheckbox': {
        return (
          <Checkbox
            onChange={(evt) => {
              handleChange(evt.target.checked);
            }}
            checked={strValue}
            children={children}
            {...otherProps}
          />
        );
      }
      case 'select': {
        return (
          <Select
            options={options}
            showSearch
            value={selectForFormatFn.valueToSelectKey(strValue)}
            onChange={(v: any, e, p) => {
              handleChange(selectForFormatFn.optionsToValue(v, options));
            }}
            allowClear
            autoMaxHeight={220}
            {...otherProps}
          />
        );
      }
      case 'treeselect': {
        return (
          <Select
            options={options}
            showSearch
            value={selectForFormatFn.valueToSelectKey(strValue)}
            onChange={(v: any, e) => {
              handleChange(selectForFormatFn.optionsToValue(v, options));
            }}
            autoMaxHeight={220}
            {...otherProps}
          />
        );
      }
      case 'textarea': {
        return (
          <CopeWrapper
            isCopyPlaceholder={isCopyPlaceholder}
            placeholder={otherProps.placeholder}
          >
            <STextArea
              value={value}
              onChange={(evt) => handleChange(evt)}
              showCount
              maxLength={200}
              rows={5}
              {...otherProps}
            />
          </CopeWrapper>
        );
      }
      case 'textareapropover': {
        return <CopeWrapper
          isCopyPlaceholder={isCopyPlaceholder}
          placeholder={otherProps.placeholder}
        >
          <TextAreaPropover
            value={value}
            onChange={(evt) => handleChange(evt)}
            textAreaProps={{
              showCount: true,
              maxLength: 200,
              rows: 5,
              ...otherProps,
            }}
            {...otherProps} />
        </CopeWrapper>
      }
      case 'input':
        return (
          <CopeWrapper
            isCopyPlaceholder={isCopyPlaceholder}
            placeholder={otherProps.placeholder}
          >
            <SInput
              value={value}
              maxLength={200}
              onChange={(evt) => handleChange(evt)}
              {...otherProps}
            />
          </CopeWrapper>
        );
      case 'switch': {
        return (
          <Switch
            checked={strValue}
            onChange={(v) => handleChange(v)}
            {...otherProps}
          />
        );
      }
      case 'inputnumber': {
        return (
          <InputNumber
            direction="vertical"
            placeholder={'请输入'}
            max={Number.MAX_SAFE_INTEGER - 1}
            toFixed={2}
            min={0}
            value={value}
            autoComplete="off"
            onChange={(v) => handleChange(v)}
            {...otherProps}
          />
        );
      }
      case 'inputpercent': {
        return (
          <SInputPercent
            direction="vertical"
            placeholder={'请输入'}
            max={Number.MAX_SAFE_INTEGER - 1}
            value={value}
            autoComplete="off"
            onChange={(v) => handleChange(v)}
            {...otherProps}
          />
        );
      }
      case 'currencytype': {
        return (
          <CurrencyType
            value={value}
            onChange={(v) => {
              handleChange({
                value: budgetToNumber(v.value),
                currency: v.currency,
              });
            }}
            {...otherProps}
          />
        );
      }
      case 'datepicker':
      case 'datePicker': {
        let values = Array.isArray(value) ? value : [value];
        const finalValues = values.map((v) => {
          return v?.isValid?.()
            ? v.format(otherProps?.format || DEFAULT_DATE_FORMAT)
            : v;
        });
        const finalValue = Array.isArray(value) ? finalValues : finalValues[0];
        return (
          <DatePicker
            value={finalValue}
            autoComplete="off"
            onChange={(changeValue: any) => {
              let changeValues = Array.isArray(changeValue)
                ? changeValue
                : [changeValue];
              let finalV = changeValues.map((v) => {
                return v && v.isValid?.()
                  ? v.format(otherProps?.format || DEFAULT_DATE_FORMAT)
                  : v;
              });
              finalV = Array.isArray(changeValue) ? finalV : finalV[0];
              return handleChange(finalV);
            }}
            {...otherProps}
          />
        );
      }
      case 'editor': {
        return (
          <Input.TextArea
            value={value}
            onChange={(v: any) => handleChange(v)}
            autoComplete="off"
            {...otherProps}
          />
        );
      }
      case 'upload': {
        return (
          <SUpload
            fileList={value}
            onChange={(valObj: any) => {
              handleChange(valObj.dataList);
            }}
            {...otherProps}
          />
        );
      }
      case 's3upload': {
        return (
          <S3Upload
            key={'edit'}
            value={value}
            onChange={handleChange}
            {...otherProps}
          />
        );
      }

      case 'numberCurrency':
      case 'numbercurrency': {
        return <NumberCurrency
          value={value}
          onChange={(v) => {
            handleChange(budgetToNumber(v));
          }}
          {...otherProps}
        />
      }

      case 'textareapopover': {
        return <TextAreaPopover {...otherProps} onChange={handleChange} value={value} />
      }

      default: {
        if (componentClass) {
          return React.createElement(
            componentClass,
            {
              ...props,
              onChange: handleChange,
            },
            children
          );
        } else {
          return <TextShow text={value} />;
        }
      }
    }
  };

  return renderItem() as React.ReactElement;
};

const WrapperPureFormItem: React.FC<
  ExtendedPureFormItemProps<SFormComponentClass>
> = (props) => {
  return (
    <SFormElementWrapper {...props}>
      <PureFormItem {...props} />
    </SFormElementWrapper>
  );
};

export default WrapperPureFormItem;
